import GET_SALOONS from '@/graphql/Saloons.gql'
import { ref } from '@vue/composition-api'
import { useQuery, useResult } from '@vue/apollo-composable'

export function useSaloons(companyId) {
  const { result, loading, error } = useQuery(
    GET_SALOONS,
    () => ({
      where: {
        ...(companyId && { companyId: companyId }),
      },
    }),
    { fetchPolicy: 'cache-first' }
  )
  const saloons = useResult(result, [], data => data.saloons)
  return { saloons, loading, error }
}
